import React, { useEffect, useState } from "react";
import { FiFilter, FiX } from "react-icons/fi";
import { ClearButton, FilterGroup, FilterGroupHeader, FilterHeader, FilterOption, FilterOptions, FilterSection, Sidebar, SidebarContainer, SidebarToggle } from "../../style/sidebar.styles";

export default function FilterSidebar({ filters }) {
  // const [selectedFilters, setSelectedFilters] = useState({
  //   employmentType: [],
  //   workMode: [],
  //   experienceLevel: [],
  //   industry: [],
  // });

  const [isExpanded, setIsExpanded] = useState(false);

  useEffect(() => {
    const handleResize = () => {
      if (window.innerWidth > 960) {
        setIsExpanded(true);
      } else {
        setIsExpanded(false);
      }
    };

    // Initial check
    handleResize();

    // Add event listener
    window.addEventListener("resize", handleResize);

    // Cleanup
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  const toggleFilter = (category, value) => {
    // setSelectedFilters((prevFilters) => {
    //   const updatedCategory = prevFilters[category].includes(value)
    //     ? prevFilters[category].filter((item) => item !== value)
    //     : [...prevFilters[category], value];

    //   return { ...prevFilters, [category]: updatedCategory };
    // });
  };

  const clearFilters = () => {
    // setSelectedFilters({
    //   employmentType: [],
    //   workMode: [],
    //   experienceLevel: [],
    //   industry: [],
    // });
  };

  return (
    <SidebarContainer>
      <SidebarToggle onClick={() => setIsExpanded(!isExpanded)}>
        {isExpanded ? (
          <>
            <span>Hide Filters</span>
            <FiX />
          </>
        ) : (
          <>
            <span>Show Filters</span>
            <FiFilter />
          </>
        )}
      </SidebarToggle>

      <Sidebar isExpanded={isExpanded}>
        <FilterSection>
          <FilterHeader>
            <h3>Filters</h3>
            <ClearButton onClick={clearFilters}>Clear all</ClearButton>
          </FilterHeader>

          {filters.map((filterGroup, groupIndex) => (
            <FilterGroup key={groupIndex}>
              <FilterGroupHeader>
                <h4>{filterGroup.filter}</h4>
              </FilterGroupHeader>

              <FilterOptions >
                {filterGroup.options.map((option) => (
                  <FilterOption
                    key={option}
                    //   isSelected={selectedFilters[filterGroup.filter.toLowerCase().replace(/\s+/g, '')].includes(option)}
                    onClick={() =>
                      toggleFilter(
                        filterGroup.filter.toLowerCase().replace(/\s+/g, ""),
                        option
                      )
                    }
                  >
                    {option}
                  </FilterOption>
                ))}
              </FilterOptions>
            </FilterGroup>
          ))}
        </FilterSection>
      </Sidebar>
    </SidebarContainer>
  );
}